export default __webpack_public_path__ + "static/media/car14.dade7a9e.jpg";